import React from "react"
import clsx from "clsx"

import RadioSelect from "../../Selects/RadioSelect"
import FormFieldBuilderErrors from "../FormFieldBuilderErrors"
import I18n from "i18n-js";


class FormFieldBuilderRatingScale extends React.Component {

  constructor(props) {
    super(props)
  }


  /*** Render Functions ***/

  render() {

    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'rating_scale',
      'tab-pane': true 
    })
    return (
      <div className={tabClasses} id='rating_scale'>
        {this.renderErrors()} 
        {this.renderRatingScaleForm()}
        <br/>
        <hr></hr>
        {this.renderRatingScalePreview()}
      </div>
    )
  }

  renderErrors() {
    var errors = FormFieldBuilderErrors.ratingScaleErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderRatingScaleForm() {
    return (
      <div>
        {/* <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('label')}*`}</label>
              <input
                id="label" 
                type="text" 
                name="rating_scale_label" 
                className={this.renderFieldClasses('label')} 
                value={this.props.rating_scale_label} 
                onChange={this.props.onChangeField} 
              />
              {this.renderFieldErrors("label")}
            
            </div>
          </div>

        </div>   */}
        <div className="row">
          <div className="col-md-3">
            <label>{`${I18n.t('range')}*`}</label>
            {this.renderRadioInputs()}
       
          
          </div>
        </div>
      </div>
    )
  }

  renderRatingScalePreview(){
    return (
      <div className="flex-container">
        <div className="row">

          <div className="col-md-6">
            <div className="form-group">
              <h5>Preview</h5>

            </div>

          </div>
        </div>
    
        <div className="row">
          <div className="col-md-6">
            <label className="form-group">{this.props.field}</label>
            <br></br>
            {this.renderRatingScaleRange()}      
          </div>
        </div>
      </div>

    )
  }

  renderRatingScaleRange() {
    if(this.props.rating_range) {
      var rating_range = parseInt(this.props.rating_range, 10)
      var rating_range_arr = []
      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }
      var rating_range_lines = rating_range_arr.map((rating) => {
        if(rating_range == 10) {

          if(rating <= 3){
            var color = "#aa381d"
          } else if (rating > 3 && rating <= 6) {
            var color = "#d18140"
          } else if (rating > 3 && rating <= 6) {
            var color = "#bba350"
          } else {
            var color = "#61a544"
          }
        }

        if(rating_range == 5) {
          if(rating < 3){
            var color = "#aa381d"
          } else if (rating  == 3) {
            var color = "#bba350"
          } else if (rating > 3 && rating <= 6) {
            var color = "#61a544"
          } else {
            var color = "#61a544"
          }

        }
        
        return (
          <li className={this.props.selected == true && this.props.selected_rating == rating ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.props.onChangeSelectedRating(rating)} key={rating} style={{borderColor: color, color:color}}>{rating}</li>
        )
      })
    }
    if(this.props.rating_range != 'none') {

      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 

  }

  renderRadioInputs() {

    var inputs_arr = ["5", "10"]
    var inputs = inputs_arr.map((input) => {
      return {
        label_primary: input,
        id: input
      }
    })
    // console.log("inputs", inputs);
    return (
      <div id="room_types">
        {/* {this.renderErrors()} */}
        <div className="row">
          <div className="col-lg-6">
            <RadioSelect
              onChange={this.props.onChangeRatingRange}
              inputs={inputs}
              selected_input={this.props.rating_range}
            />
            {this.renderFieldErrors("range")}
          </div>
        </div>
      </div>
    )
  }



}

export default FormFieldBuilderRatingScale